import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { db } from "../../firebase/firebase";
import { getDocs, collection, query, limit, where } from "firebase/firestore";
import { QueryKeys } from "config/query-keys";
import { QueryParamsConfig } from "hooks/useFilterPagination";
import { GetJobsInterface, JobInterface, JOB_STATUS } from "./dto";

const getJobs = async (params: QueryParamsConfig): Promise<GetJobsInterface> => {
  try {
    const {
      page = 1,
      pageSize = 20,
      findByProvince,
      findByDistrict,
      findByJobType,
    } = params;

    const jobCollectionRef = collection(db, "jobs");
    let jobQuery = query(jobCollectionRef, where("status", "==", JOB_STATUS.PUBLISHED), limit(pageSize));

    let findByProvincename = "";
    if (findByProvince) {
      try {
        findByProvincename = JSON.parse(findByProvince).name;
      } catch {
        findByProvincename = findByProvince;
      }
    }

    let findByDistrictname = "";
    if (findByDistrict) {
      try {
        findByDistrictname = JSON.parse(findByDistrict).name;
      } catch {
        findByDistrictname = findByDistrict;
      }
    }

    if (findByJobType) {
      jobQuery = query(
        jobQuery,
        where("jobType", "==", findByJobType)
      );
    }

    const rawData = await getDocs(jobQuery);
    let jobs: JobInterface[] = rawData.docs.map((doc) => ({
      ...doc.data(),
      id: doc.id,
    })) as JobInterface[];

    if (findByProvincename) {
      jobs = jobs.filter((job) =>
        job.joblocation?.some(
          (loc) => loc.province === findByProvincename
        )
      );
    }

    if (findByDistrictname) {
      jobs = jobs.filter((job) =>
        job.joblocation?.some(
          (loc) => loc.district === findByDistrictname
        )
      );
    }

    return {
      data: jobs,
      page,
      pageSize,
      totalData: jobs.length,
      isLastPage: jobs.length < pageSize,
    };
  } catch (error) {
    console.error("Error fetching jobs:", error);
    throw error;
  }
};

export const useGetJobs = (params: QueryParamsConfig) => {
  return useQuery<GetJobsInterface, AxiosError>({
    queryKey: [QueryKeys.JOBS, params],
    queryFn: () => getJobs(params),
    staleTime: 1000 * 60 * 5,
  });
};
